import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { normalizeAppLanguage } from "./helpers/userPreferences";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

export const languageDetectionOptions = {
  // A stale i18next cookie previously won over the language selected in
  // the app. The explicit local-storage-first order makes refreshes
  // deterministic while navigator remains the first-visit fallback.
  order: ["localStorage", "navigator"],
  lookupLocalStorage: "i18nextLng",
  caches: ["localStorage"],
  convertDetectedLanguage: (language: string) =>
    normalizeAppLanguage(language) ?? "en",
};

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "no"],
    load: "languageOnly",
    debug: false,
    detection: languageDetectionOptions,
    ns: [
      "common",
      "planner",
      "orders",
      "order_form",
      "user",
      "vehicles",
      "validation",
      "products",
      "map",
      "location",
      "inventory",
      "stats",
      "navigation",
      "translation",
      "reports",
      "driver",
      "company",
      "customer",
      "workspace",
      "invoice",
      "modals",
      "configuration",
      "help",
      "administration",
      "onboarding",
    ],
    defaultNS: "common",
    backend: {
      // Locale files are not content-hashed. Always revalidate them so a new
      // app bundle cannot be paired with translations cached from an older deploy.
      requestOptions: { cache: "no-cache" },
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
